var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M64,0h54.51a9.37,9.37,0,0,1,9.41,7.7A9.72,9.72,0,0,1,128,9.13V118.84a9.1,9.1,0,0,1-8.69,9.07H9.59c-4.55,0-8-2.45-9.19-6.57a9.89,9.89,0,0,1-.38-2.7Q0,64,0,9.3A9.07,9.07,0,0,1,8.87.05H22.29Zm5,109.11V78.32a35.15,35.15,0,0,1,.5-6.06c.74-4.14,2.65-7.48,7.08-8.58a16.94,16.94,0,0,1,4.14-.38c4.56.06,7.41,2.2,8.41,6.63a35.72,35.72,0,0,1,.8,7.57c.09,9.94,0,19.88,0,29.82,0,.58.07,1.16.11,1.8h19.1c0-.5.06-.89.06-1.28,0-11.78.11-23.56-.07-35.33a54.76,54.76,0,0,0-1.45-11.33c-1.43-6.26-4.93-11-11.2-13.32A29.18,29.18,0,0,0,84,46.36a19.6,19.6,0,0,0-15.28,9c-.12.17-.27.32-.63.73V47.93H49.79v61.22Zm-50.17,0H38V47.94H18.84ZM28.4,39.64A11.11,11.11,0,1,0,17.31,28.51v.13a11,11,0,0,0,11,11Z","transform":"translate(0 0)"}));
}

Linkedin.defaultProps = {"viewBox":"0 0 128 127.91"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
